import inputText from '../components/input-text'
import inputTextArea from '../components/input-text-area'
import inputCheckRadio from '../components/input-check-radio'
import inputSelect from '../components/input-select'

import DatepickerNew from 'vuejs-datepicker-new'
import { sv } from 'vuejs-datepicker-new/dist/locale'
import moment from 'moment'

export default {

    components: {
        inputText,
        inputTextArea,
        inputCheckRadio,
        inputSelect,
        DatepickerNew
    },

    data () {
        return {
            former: {
                errors: {},
                unhandled_error: false,
                datepicker: {
                    locale: sv
                }
            }
        }
    },

    provide () {
        return {
            getError: this.getError,
            clearError: this.clearError
        }
    },

    methods: {

        getError (field) {
            // console.log('getError ' + field)
            return this.former.errors[field]
        },

        clearError (field) {
            // console.log('clearError ' + field)
            this.former.errors[field] = null
        },

        formerDateFormat (date) {
            return moment(date).format('YYYY-MM-DD')
        }

    }
}
